import React from "react";
import { greeting, socialMediaLinks } from "portfolio";
import type { Theme } from "types";

interface FooterProps {
  theme: Theme;
}

export default function Footer(props: FooterProps): React.ReactElement {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="border-t border-border mt-24 md:mt-32">
      {/* CTA Row */}
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8">
          <div>
            <p className="font-mono text-xs tracking-[0.12em] uppercase text-text-muted mb-4">
              Available for opportunities
            </p>
            <h2 className="font-display text-3xl md:text-5xl font-bold tracking-tight text-text-primary leading-tight">
              Let&apos;s build something
              <br />
              <span className="text-accent">intelligent</span>
            </h2>
          </div>
          <a
            href={`mailto:${greeting.mail}`}
            className="font-mono text-sm text-text-secondary hover:text-accent transition-colors duration-200 link-underline shrink-0 inline-flex items-center min-h-[44px]"
          >
            {greeting.mail}
          </a>
        </div>
      </div>

      {/* Bottom Row */}
      <div className="border-t border-border">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="font-mono text-xs text-text-muted">
            &copy; {new Date().getFullYear()} {greeting.title2}. All rights
            reserved.
          </p>

          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-1">
            {socialMediaLinks.github && (
              <a
                href={socialMediaLinks.github}
                target="_blank"
                rel="noopener noreferrer"
                className="font-mono text-xs text-text-muted hover:text-accent transition-colors duration-200 link-underline inline-flex items-center min-h-[44px] px-2"
              >
                GitHub
              </a>
            )}
            {socialMediaLinks.linkedin && (
              <a
                href={socialMediaLinks.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="font-mono text-xs text-text-muted hover:text-accent transition-colors duration-200 link-underline inline-flex items-center min-h-[44px] px-2"
              >
                LinkedIn
              </a>
            )}
            {socialMediaLinks.x && (
              <a
                href={socialMediaLinks.x}
                target="_blank"
                rel="noopener noreferrer"
                className="font-mono text-xs text-text-muted hover:text-accent transition-colors duration-200 link-underline inline-flex items-center min-h-[44px] px-2"
              >
                X
              </a>
            )}
            {socialMediaLinks.gmail && (
              <a
                href={`mailto:${socialMediaLinks.gmail}`}
                className="font-mono text-xs text-text-muted hover:text-accent transition-colors duration-200 link-underline inline-flex items-center min-h-[44px] px-2"
              >
                Email
              </a>
            )}
            <button
              onClick={scrollToTop}
              className="font-mono text-xs text-text-muted hover:text-accent transition-colors duration-200 inline-flex items-center gap-1 min-h-[44px] px-1"
              aria-label="Back to top"
            >
              Top
              <svg
                className="w-3 h-3"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M5 10l7-7m0 0l7 7m-7-7v18"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
